<template>
  <el-dialog title="资产申领" :visible.sync="show" :before-close="close" center destroy-on-close>
    <el-form ref="form" :rules="rules" :model="info" label-width="22%">
      <el-row>
        <el-col :span="24">
            <el-form-item label="资产编号" prop="assetsNo">
              <el-input disabled placeholder="请输入资产编号" show-word-limit v-model="info.assetsNo"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="物品名称" prop="assetsName">
              <el-autocomplete
                :disabled="type !== 'new'"
                v-model="info.assetsName"
                :fetch-suggestions="querySearchAsync"
                placeholder="请输入搜索物品名称"
                @select="handleSelect"
                style="width:100%"
              ></el-autocomplete>
              <!-- <el-input  placeholder="请输入物品名称" show-word-limit v-model="info.assetsName" /> -->
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="品牌" prop="brand">
              <el-input disabled placeholder="请输入品牌" show-word-limit v-model="info.brand" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="库存量" prop="inventory" class="formItem" v-if="actionType === 'new' || actionType === 'update'">
               <el-input-number v-model="info.inventory" :min="0"  placeholder="大于等于0"
                    style="width:100%;" :controls="false"
                    disabled></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="领用数量" prop="amount" class="formItem">
               <el-input-number v-model="info.amount" :min="0"  placeholder="大于等于0"
                    style="width:100%;" :controls="false"
                    :disabled="type !== 'new'"></el-input-number>
            </el-form-item>
          </el-col>
        <template v-if="auditInfo.approvalFlag && activeName === 'queryMyAudit'">
          <el-col :span="24">
            <el-form-item label="审核状态" prop="status" :rules="{
              required: true, message: '请选择审核状态', trigger: 'change'
            }">
              <el-select v-model="info.status" @change="handleRemark">
                <el-option :value="item.value" :label="item.label"  v-for="(item,index) in statusOptions" :key="index"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="审核原因">
              <el-input type="textarea" :rows="3" placeholder="请输入审核原因" @input="changeMessage($event)"
                v-model="info.remark" />
            </el-form-item>
          </el-col>
        </template>
        <template v-if="type === 'new' || info.status === 0">
          <el-col :span="24">
            <approvalRadio  v-model="isSubmitApproval" v-show="type === 'new'" />
          </el-col>
          <el-col :span="24">
            <el-form-item label="下一级审核人" prop="auditPersonId" v-if="activeName == 'queryMine'">
              <el-select v-model="info.auditPersonId" placeholder="请选择" clearable filterable :disabled="type !== 'new'" style="width:100%">
                <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName" :value="item.userName">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="下一级审核人" prop="auditPersonId" v-else>
            <el-input v-model="this.info.auditPerson" disabled />
          </el-form-item>
          </el-col>
        </template>
        <template v-if="activeName == 'queryMyAudit'">
          <el-col :span="24">
            <el-form-item label="是否结束审核" prop="lastUserFlag" v-if="info.status == '1'">
              <el-radio v-model="info.lastUserFlag" :label="1">是</el-radio>
              <el-radio v-model="info.lastUserFlag" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <approvalRadio  v-model="isSubmitApproval" v-show="info.status == '1' && info.lastUserFlag == 0"/>
          </el-col>
          <el-col :span="24">
            <el-form-item label="下一级审核人" prop="nextAuditUserName" v-if="info.status == '1' && info.lastUserFlag == 0">
              <el-select v-model="info.nextAuditUserName" placeholder="请选择" clearable filterable>
                <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName" :value="item.userName">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <approvalRadio  v-model="isSubmitApproval" v-show="info.status == '3'"/>
          </el-col>
          <el-col :span="24">
            <el-form-item label="转办人" prop="nextAuditUserName" v-if="info.status == '3'">
              <el-select v-model="info.nextAuditUserName" placeholder="请选择" clearable filterable>
                <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName" :value="item.userName">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </template>
      </el-row>
    </el-form>
    <review-process v-show="type !== 'endUseCar'" :processList="auditInfo.auditProcessEntityList"
      :createTime="auditInfo.createTime" :createUser="auditInfo.applyUser" :auditPerson="auditInfo.auditPerson" />
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="addEventForm()" v-if="type === 'new' || activeName === 'queryMyAudit'">提 交</el-button>
      <el-button type="primary" @click="addStagingForm()" v-if="(type === 'new' && info.status === 10) || (type === 'new' && info.status === '')">暂
        存</el-button>
      <el-button @click="close">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ReviewProcess from '@/components/ReviewProcess.vue'
// import { queryUserInfo } from '@/api/basicInfo'
import { compAssetsInfo, compApplyAssetsReceive } from '@/api/assets.js'
import approval from '@/mixins/approval'
export default {
  mixins: [approval],
  components: {
    ReviewProcess
  },
  data() {
    var validateAmount = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入领取数量'));
        } else if (value > this.info.inventory) {
          callback(new Error('领取数量不能大于库存数量'));
        } else {
          callback();
        }
      };
    return {
      timeValue: [],
      info: {
        assetsNo: '', // 资产编号
        assetsName: '', // 资产名称
        brand: '', // 品牌
        inventory: '', // 库存量
        amount: '', // 领用数量
        status: '',

        lastUserFlag: '',
        nextAuditUserName: '',
        auditPersonId: '',
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      carList: [],
      statusOptions: [
        {
          value: '1',
          label: '通过'
        },
        {
          value: '2',
          label: '拒绝'
        },
        {
          value: '3',
          label: '转办'
        },
        {
          value: '4',
          label: '退回上一级'
        },
      ],
      rules: {
        assetsNo: [{ required: true, message: '请输入', trigger: 'change' }],
        assetsName: [{ required: true, message: '请输入', trigger: 'change' }],
        brand: [{ required: true, message: '请输入', trigger: 'change' }],
        inventory: [{ required: true, message: '请输入', trigger: 'blur' }],
        amount: [{ validator: validateAmount, trigger: 'blur' }],
        applyReason: [{ required: true, message: '请输入申请原因', trigger: 'blur' }],
        nextAuditUserName: [{ required: true, message: '请选择下一级审核人', trigger: 'change' }],
        auditPersonId: [{ required: true, message: '请选择下一级审核人', trigger: 'change' }],
        lastUserFlag: [{ required: true, message: '请选择是否结束审核', trigger: 'change' }],
      },
      id: '',
      type: '',
      actionType: '',
      show: false,
      // userInfoList: [],
      activeName: '',
      auditInfo: {
        auditProcessEntityList: [],
        createTime: '',
        applyUser: '',
        auditPerson: '',
        approvalFlag: false
      }
    }
  },
  mounted() {
    this.queryList()
  },
  methods: {
    async querySearchAsync(queryString, cb) {
      const { result: { records } } = await compAssetsInfo('query', { assetsName: queryString })
      let newrecords = records.map(v => {
        return {
          value: v.assetsName + '-' + v.brand,
          ...v
        }
      })
      cb(newrecords)
    },
    handleSelect(item) {
      this.info = {
        assetsNo: item.assetsNo, // 资产编号
        assetsName: item.assetsName, // 资产名称
        brand: item.brand, // 品牌
        inventory: item.inventory, // 库存量
        status: '',
        amount: '',

        lastUserFlag: '',
        nextAuditUserName: '',
        auditPersonId: '',
      }
      this.$refs['form'].resetFields();
    },
    handleStatus(creatUser) {
     let userName = JSON.parse(localStorage.getItem('jiadingFangwu_userInfo')).userName
     if (userName === creatUser) {
      this.statusOptions = [
        {
          value: '1',
          label: '通过'
        },
        {
          value: '2',
          label: '拒绝'
        },
        {
          value: '3',
          label: '转办'
        },
      ]
     }
    },
    handleRemark(val) {
      if (val === '1') {
        this.info.remark = '同意'
      } else if (val === '3') {
        this.info.remark = '转办'
      } else {
        this.info.remark = ''
      }
    },
    // 强制更新测试文本信息框的值
    changeMessage() {
      this.$forceUpdate()
    },
    // async queryList() {
    //   let res = await queryUserInfo({
    //     pageNum: 1,
    //     pageSize: 9999,
    //   })
    //   if (res.code === 0) {
    //     this.userInfoList = res.result.records
    //   }
    // },
    showDetails(type, id, activeName) {
      this.type = type
      this.show = true
      this.activeName = activeName
      if (id) {
        this.getDetails(id)
      }
    },
    async getDetails(id) {
      this.id = id
      await compApplyAssetsReceive('getApplyDetail', { id }).then(res => {
        const { code, result } = res
        if (code !== 0) return
        this.handleStatus(result.createUser)
        this.info = {
          assetsNo: result.assetsNo,
          assetsName: result.assetsName,
          brand: result.brand,
          inventory: result.inventory,
          amount: result.amount,
          eventId: result.eventId,
          lastUserFlag: result.lastUserFlag,
          nextAuditUserName: result.nextAuditUserName,
          auditPersonId: result.auditPersonId,
          status: result.approvalFlag === true ? '' : result.status,
        }
        this.timeValue = [result.begin, result.end]
        this.auditInfo = {
          auditProcessEntityList: result.auditProcessEntityList,
          createTime: result.createTime,
          applyUser: result.applyUser,
          auditPerson: result.auditPerson,
          approvalFlag: result.approvalFlag
        }
        if (this.type === 'new' && this.info && this.info.auditPersonId && result.status === 10) {
          this.info.auditPersonId = ''
        }
      })
      const { result: { records } } = await compAssetsInfo('query', { assetsName: this.info.assetsName, assetsNo: this.info.assetsNo })
      this.info.inventory = records[0].inventory
    },
    async getFixedAssetsDetails(type, item, activeName) {
      this.type = type
      this.show = true
      this.activeName = activeName
      this.id = item.id
      await compApplyAssetsReceive('getApplyDetail', { id: item.id }).then(res => {
        const { code, result } = res
        if (code !== 0) return
        this.handleStatus(result.createUser)
        this.info = {
          assetsNo: result.assetsNo,
          assetsName: result.assetsName,
          brand: result.brand,
          inventory: result.inventory,
          amount: result.amount,
          eventId: result.eventId,
          lastUserFlag: result.lastUserFlag,
          nextAuditUserName: result.nextAuditUserName,
          auditPersonId: result.auditPersonId,
          status: result.approvalFlag === true ? '' : result.status,
        }
        this.timeValue = [result.begin, result.end]
        this.auditInfo = {
          auditProcessEntityList: result.auditProcessEntityList,
          createTime: result.createTime,
          applyUser: result.applyUser,
          auditPerson: result.auditPerson,
          approvalFlag: result.approvalFlag
        }
      })
      const { result: { records } } = await compAssetsInfo('query', { assetsName: this.info.assetsName, assetsNo: this.info.assetsNo })
      this.info.inventory = records[0].inventory
    },
    
    close() {
      this.show = false
      this.timeValue = []
      this.info = {
        assetsNo: '', // 资产编号
        assetsName: '', // 资产名称
        brand: '', // 品牌
        inventory: '', // 库存量
        amount: '', // 领用数量
        eventId: '',

        lastUserFlag: '',
        nextAuditUserName: '',
        auditPersonId: '',
      }
      this.id = ''
      this.auditInfo = {
        auditProcessEntityList: [],
        createTime: '',
        applyUser: '',
        auditPerson: '',
        approvalFlag: false
      }
    },
    addEventForm() {
      this.$refs.form.validate(async (vaild) => {
        if (vaild) {
          let res = {}
          console.log(this.info);
          if (this.actionType === 'new' || this.actionType === 'update') {
            let params = {
              ...this.info,
              id: this.id,
            }
            delete params.lastUserFlag
            delete params.nextAuditUserName
            delete params.inventory
            res = await compApplyAssetsReceive('submitAssetsReceiveApply', params)
          }
          // if (this.actionType === 'update') {
          //   res = await compApplyAssetsReceive('submitAssetsReceiveApply',{
          //     id: this.id,
          //     ...this.info,
          //     status: 0
          //   })
          // }
          if (this.auditInfo.approvalFlag) {
            res = await compApplyAssetsReceive('auditAndNextUser', {
              id: this.id,
              remark: this.info.remark,
              status: this.info.status,
              lastUserFlag: this.info.lastUserFlag,
              nextAuditUserName: this.info.nextAuditUserName,
            })
          }
          const { code, message } = res
          if (code !== 0) {
            this.$message.error(message)
            return
          }

          this.$message.success('提交成功！')
          this.$emit('addSuccess')
          this.close()
        }
      })
    },
    async addStagingForm() {
      this.$refs.form.validate(async (vaild) => {
        if (vaild) {
          let params = { ...this.info }
          delete params.lastUserFlag
          delete params.nextAuditUserName
          delete params.inventory
          let res = await compApplyAssetsReceive('stagingApply', params)
          const { code, message } = res
          if (code !== 0) {
            this.$message.error(message)
            return
          }
          this.$message.success('暂存成功！')
          this.$emit('addSuccess')
          this.close()
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
  min-width: 540px;
  width: 50%;
}
</style>
